import { 
    LOADINGMAIN_CLOSE,
    LOADINGMAIN_OPEN,
} from "../actions/types";

const initialState = {
    isOpen: false,
    shape: "circle",
    text: null,
    maxWidth: null
};

export default function loadingMain(state = initialState, action) {
    const { type, payload} = action;
    switch (type) {
        case LOADINGMAIN_OPEN:
            return { ...state, ...payload, isOpen: true };
        case LOADINGMAIN_CLOSE:
            return { ...initialState };
        default:
            return state;
    }
}
